<template>
    <DCard padding>
        <DTable
            :items="settingsItems"
            :fields="columns"
        >
            <template #actions="{item}">
                <td>
                    <DButton
                        :id="`btn-edit-` + (item.index + 1)"
                        mini
                        icon="pencil"
                        @click="openEditModal(item)"
                    />
                    <DButton
                        v-if="item.segment_name"
                        :id="`btn-delete-${item.index}`"
                        mini
                        color="danger"
                        icon="trash-can-outline"
                        @click="toDelete=item;showConfirmModal=true"
                    />
                </td>
            </template>
            <template #segment_name="{item}">
                <td v-if="item.segment_name">
                    {{ item.segment_name }}
                </td>
                <td v-else />
            </template>
        </DTable>

        <DFabs v-if="canAddLimit">
            <DFab
                id="btn-add"
                icon="plus"
                :label=" __('settings.contracts.add_limit')"
                @click="openNewLimitModal"
            />
        </DFabs>

        <DModal
            v-model:show="showModal"
            :title="__('settings.contracts.add_limit')"
            is-big
            @close="showModal = false"
        >
            <div style="padding: 15px">
                <DFormRow
                    v-if="!modal.edit || modal.segment_name !== null"
                    :label="__('settings.contracts.segment')"
                    is-required
                    :error="modal.errors.customer_segment_id"
                    :hint="__('settings.contracts.segment_hint')"
                >
                    <DSelect
                        v-if="!modal.edit"
                        id="customer_segment"
                        v-model="modal.customer_segment_id"
                        :options="segmentOptions"
                    />
                    <span v-else>{{ modal.segment_name }}</span>
                </DFormRow>
                <DFormRow
                    :label="__('settings.contracts.number_of_invoices')"
                    :error="modal.errors.number_of_invoices"
                    is-required
                    :hint="__('settings.contracts.number_of_invoices_hint')"
                >
                    <DInput
                        id="number_of_invoices"
                        v-model="modal.number_of_invoices"
                        :is-valid="limitIsValid('number_of_invoices')"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.contracts.debt_limit')"
                    :error="modal.errors.debt_limit"
                    is-required
                    :hint="__('settings.contracts.debt_limit_hint')"
                >
                    <DInput
                        id="debt_limit"
                        v-model="modal.debt_limit"
                        :is-valid="limitIsValid('debt_limit')"
                    />
                </DFormRow>
            </div>
            <template #actions>
                <DButton
                    id="btn-save"
                    :label="__('messages.save')"
                    @click="saveLimit()"
                />
            </template>
        </DModal>

        <DModal
            v-model:show="showConfirmModal"
            :title="__('settings.contracts.delete_confirm.title')"
            :message="deleteConfirmMessage"
            is-error
            is-confirm
            @confirm="deleteLimit(toDelete.id)"
            @close="showConfirmModal = false"
        />
    </DCard>
</template>

<script>
export default {
    name: 'Index',
    props: {
        settings: {
            type: Array,
            default: () => []
        },
        canAddLimit: {
            type: Boolean,
            default: false
        },
        segments: {
            type: Array,
            default: () => []
        },
        errors: {
            type: Object,
            default () { return {} }
        }
    },
    data () {
        return {
            columns: [
                { key: 'id', label: this.__('settings.contracts.id') },
                { key: 'segment_name', label: this.__('settings.contracts.segment') },
                { key: 'number_of_invoices', label: this.__('settings.contracts.number_of_invoices') },
                { key: 'debt_limit', label: this.__('settings.contracts.debt_limit') },
                { key: 'actions', label: '' }
            ],
            showModal: false,
            showConfirmModal: false,
            toDelete: null,
            modal: {
                errors: this.errors,
                customer_segment_id: null,
                number_of_invoices: '',
                debt_limit: '',
                segment_name: '',
                edit: false
            }
        }
    },
    computed: {
        settingsItems () {
            return this.settings.map((setting, index) => ({ index, ...setting }))
        },
        segmentOptions () {
            const options = []
            for (let i = 0; i < this.segments.length; ++i) {
                if (this.settings.find(setting => setting.customer_segment_id === this.segments[i].id)) {
                    continue
                }

                options.push(
                    {
                        label: this.segments[i].name,
                        value: this.segments[i].id
                    }
                )
            }
            return options
        },
        deleteConfirmMessage () {
            return this.__('settings.contracts.delete_confirm.message').replace('{segment}', this.toDelete?.segment_name)
        }
    },
    watch: {
        errors () {
            this.modal.errors = this.errors
        }
    },
    methods: {
        saveLimit () {
            if (this.modal.edit) {
                this.$inertia.patch(this.$route('settings.order-block-limit-settings.update', this.modal.id), this.modal, { onSuccess: () => { this.showModal = false } })
            } else {
                this.$inertia.post(this.$route('settings.order-block-limit-settings.store'), this.modal, { onSuccess: () => { this.showModal = false } })
            }
        },
        deleteLimit (id) {
            this.$inertia.delete(this.$route('settings.order-block-limit-settings.destroy', id))
        },
        openNewLimitModal () {
            this.modal.errors = {}
            this.modal.customer_segment_id = this.segmentOptions.at(0)?.value
            this.modal.number_of_invoices = ''
            this.modal.debt_limit = ''
            this.modal.edit = false
            this.showModal = true
        },
        openEditModal (setting) {
            this.modal.errors = {}
            this.modal.id = setting.id
            this.modal.customer_segment_id = null
            this.modal.segment_name = setting.segment_name
            this.modal.number_of_invoices = setting.number_of_invoices
            this.modal.debt_limit = setting.debt_limit
            this.modal.edit = true
            this.showModal = true
        },
        limitIsValid (field) {
            return this.modal[field] !== '' && typeof this.modal.errors[field] === 'undefined' && this.modal[field] > 0
        }
    }
}
</script>

<style scoped>

</style>
